import React from "react";
import { RouteComponentProps, RouterProps, Redirect } from "react-router";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import {
    SetHeader,
    ShowBackNavigationWithRoute,
    showBackButton,
    SetShowBackNavigation,
} from "../../ducks/common";
import { connect } from "react-redux";
import ChangePasswordForm, {
    ChangePasswordFormData,
} from "./components/ChangePasswordForm";
import { Grid } from "material-ui";
import { changePassword } from "../../ducks/user";
import logger from "../../util/logger";
import { getSecureStorage, clearSecureStorage } from "util/storage";

interface IChangePasswordPageProps
    extends RouteComponentProps<{ verificationHash: string }> {}
interface IChangePasswordPageReduxProps {}
interface IChangePasswordPageDispatchProps {
    ChangePassword: (
        password: string,
        verifyPassword: string,
        verificationHash: string
    ) => Promise<string>;
    SetHeaderValue: (header: string) => void;
    SetBackButton: (route: string) => void;
    ShowBackButton: (show: boolean) => void;
}

interface IChangePasswordPageState {}

type ChangePasswordPageProps = IChangePasswordPageProps &
    IChangePasswordPageReduxProps &
    IChangePasswordPageDispatchProps &
    RouterProps;

class ChangePasswordPage extends React.Component<
    ChangePasswordPageProps,
    IChangePasswordPageState
> {
    constructor(props: ChangePasswordPageProps) {
        super(props);
    }
    componentDidMount() {
        this.props.SetHeaderValue("");
        this.props.SetBackButton("/profile");
    }
    componentWillUnmount() {
        this.props.SetHeaderValue("");
        this.props.ShowBackButton(false);
    }
    changePassword = async (data: ChangePasswordFormData) => {
        this.props
            .ChangePassword(
                data.password,
                data.verifyPassword,
                this.props.match.params.verificationHash
            )
            .then(() => {
                clearSecureStorage();
                this.props.history.push("/profile");
            })
            .catch((err) => logger.error(err));
    };

    render() {
        if (!this.props.match.params.verificationHash) {
            return <Redirect to="/eidentify/3" />;
        }
        return (
            <div className="LoginPage_Container container-with-logo">
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}
                >
                    <Grid container spacing={0} justify="center">
                        <Grid item xs={12} sm={10} md={6}>
                            <h1
                                className={"loginHeader"}
                                style={{ color: "#646363" }}
                            >
                                Vaihda salasana
                            </h1>
                            <ChangePasswordForm
                                form="changepassword"
                                onSubmit={this.changePassword}
                            />
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): IChangePasswordPageReduxProps => {
    return {
        // ...mapStateToProps
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IChangePasswordPageDispatchProps => {
    return {
        // ...mapDispatchToProps
        ChangePassword: async (password, verifyPassword, verificationHash) => {
            return dispatch(
                changePassword(password, verifyPassword, verificationHash)
            );
        },
        SetHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        SetBackButton: (route) => {
            return dispatch(ShowBackNavigationWithRoute(route));
        },
        ShowBackButton: (show) => {
            return dispatch(SetShowBackNavigation(false));
        },
    };
};
export default connect<
    IChangePasswordPageReduxProps,
    IChangePasswordPageDispatchProps,
    IChangePasswordPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(ChangePasswordPage);



// WEBPACK FOOTER //
// ./src/views/profile/ChangePasswordPage.tsx